/**
 * TanStack Query hooks for `multi-channel-influencer-campaign-roi-dashboard`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	multiChannelInfluencerCampaignRoiDashboardQueryKeys,
	type CreateMultiChannelInfluencerCampaignRoiDashboardBody,
	type ListMultiChannelInfluencerCampaignRoiDashboardResponse,
	type MultiChannelInfluencerCampaignRoiDashboardRow,
} from "./api";

export function useMultiChannelInfluencerCampaignRoiDashboardList(): UseQueryResult<ListMultiChannelInfluencerCampaignRoiDashboardResponse, Error> {
	return useQuery({
		queryKey: multiChannelInfluencerCampaignRoiDashboardQueryKeys.list(),
		queryFn: list,
	});
}

export function useMultiChannelInfluencerCampaignRoiDashboardCreate(): UseMutationResult<MultiChannelInfluencerCampaignRoiDashboardRow, Error, CreateMultiChannelInfluencerCampaignRoiDashboardBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: multiChannelInfluencerCampaignRoiDashboardQueryKeys.all });
		},
	});
}

export function useMultiChannelInfluencerCampaignRoiDashboardDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: multiChannelInfluencerCampaignRoiDashboardQueryKeys.all });
		},
	});
}
